export const resetReservationGraceTimeMilliseconds = 60000 as const; // = 1 minute
